import React, { useRef, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Routes, Route, Link, NavLink, useLocation } from "react-router-dom";
import Home from './views/Home';
import HowItWorks from './views/HowItWorks';
import Contact from './views/Contact';
import VerifyEmail from './views/VerifyEmail';
import ResetPassword from './views/ResetPassword';
import SavingsSimulator from './views/SavingsSimulator';
import DeleteAccount from './views/DeleteAccount';
import Privacy from './views/Privacy';
import { Row, Col } from 'react-bootstrap';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

function App() {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
  
  const location = useLocation();
  useEffect(() => {
    document.title = "Laddvis.se - spara pengar på elbilsladdning";
    document.querySelector('link[rel="icon"]').href = `${process.env.PUBLIC_URL}/images/logga_mini.png`;
  }, []);

  return (
    <div className='app-container'>
      <nav className="navbar navbar-expand-lg app-navbar">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src="./images/logga_withtext.png" alt="Laddvis" style={{maxHeight: '60px', width: 'auto'}} />
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded={!isNavCollapsed ? true : false} aria-label="Toggle navigation" onClick={handleNavCollapse}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} end to="/">
                  Hem
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/how-it-works">
                  Hur fungerar appen?
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/savings-simulator">
                  Besparingskalkylator
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/contact">
                  Kontakt
                </NavLink>
              </li>              
            </ul>
          </div>
        </div>
      </nav>
      <div className="content-wrap">
        <div className="container mt-4">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/verifyEmail" element={<VerifyEmail />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/savings-simulator" element={<SavingsSimulator />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/privacy-policy" element={<Privacy />} />
          </Routes>
        </div>
      </div>
      <footer className="app-footer">
        <div className="container">
          <Row className="align-items-center">
            <Col xs={12} md={4} className="mb-3 mb-md-0 text-center text-md-start">
              <div className="google-play-badge d-inline-block">
                <a href="https://play.google.com/store/apps/details?id=se.laddvis" target="_blank" rel="noopener noreferrer">
                  <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Get it on Google Play" />
                </a>
              </div>
            </Col>
            <Col xs={12} md={4} className="mb-3 mb-md-0 text-center">
              <div className="app-store-badge d-inline-block">
                <a href="https://apps.apple.com/se/app/laddvis/id6479522235" target="_blank" rel="noopener noreferrer">
                  <img src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/en-us?releaseDate=1621209600" alt="Download on the App Store" />
                </a>
              </div>
            </Col>
            <Col xs={12} md={4} className="text-center text-md-end">
              <div>
                &copy; {new Date().getFullYear()} Onytec AB
              </div>
            </Col>
          </Row>
        </div>
      </footer>
    </div>
  );
}

export default App;
